import { useGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchesBranchIdStats } from '@fukuri-admins/apis/client/gen/endpoints';

export const useGetStressAssessmentBranchStats =
  useGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdBranchesBranchIdStats;
